import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { RAIN_IMG } from "../lib/site";

export default function RainBand() {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
    const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

    return (
        <section
            ref={ref}
            className="relative h-[46vh] min-h-[320px] overflow-hidden flex items-center"
            data-testid="rain-band"
        >
            <motion.img
                style={{ y }}
                src={RAIN_IMG}
                alt="Gocce di pioggia su una superficie di vetro"
                className="absolute inset-0 w-full h-[124%] object-cover img-treated"
                loading="lazy"
            />
            <div className="absolute inset-0 bg-bitume/55" />
            <div className="relative max-w-7xl mx-auto px-5 md:px-8 w-full">
                <motion.p
                    initial={{ opacity: 0, y: 18 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.4 }}
                    transition={{ duration: 0.7 }}
                    className="eyebrow mb-4"
                >
                    Il nostro metodo
                </motion.p>
                <h2 className="font-display font-bold uppercase tracking-tight leading-[1.02] text-3xl sm:text-4xl lg:text-5xl max-w-2xl">
                    <span className="block overflow-hidden pb-1">
                        <motion.span
                            className="block"
                            initial={{ y: "110%" }}
                            whileInView={{ y: 0 }}
                            viewport={{ once: true, amount: 0.4 }}
                            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
                        >
                            Diagnosi onesta,
                        </motion.span>
                    </span>
                    <span className="block overflow-hidden pb-1">
                        <motion.span
                            className="block text-ambra"
                            initial={{ y: "110%" }}
                            whileInView={{ y: 0 }}
                            viewport={{ once: true, amount: 0.4 }}
                            transition={{ duration: 0.9, delay: 0.12, ease: [0.16, 1, 0.3, 1] }}
                        >
                            riparazioni che tengono.
                        </motion.span>
                    </span>
                </h2>
            </div>
        </section>
    );
}
